const initialState = {
    open: false,
    vertical: 'top',
    horizontal: 'right',
    severity: 'error', // error | warning | info | success
    variant: 'filled', // filled | outlined
    message: ''
};
const custom_snackbar = (state = initialState, action) => {
    switch (action.type) {
        
        case 'SET_OPEN_CUSTOM_SNACKBAR':

        	if(action.data !== undefined)
	            return {...state, 
	            	open:  action.open, 
	            	vertical: action.data.vertical !== undefined ? action.data.vertical : state.vertical,
	            	horizontal: action.data.horizontal !== undefined ? action.data.horizontal : state.horizontal,
	            	severity: action.data.severity !== undefined ? action.data.severity : state.severity,
	            	variant: action.data.variant !== undefined ? action.data.variant : state.variant,
	            	message: action.data.message !== undefined ? action.data.message : state.message
	            };
	        else
            	return {...state, open:  action.open};

        default:
            return state;
    }
};

export default custom_snackbar;
